import { jwtDecode } from "jwt-decode";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

// Utility function to check if the token is expired
export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    return exp < (Date.now() / 1000) + 60;
  } catch (e) {
    console.error('Failed to decode token:', e);
    return true;
  }
};

export const refreshToken = async() => {
    try{
        const response = await axios.post(`${BASE_URL}/auth/refresh-token`, {}, {withCredentials: true});
        const newToken = response?.data?.data?.token;
        localStorage.removeItem('_token');
        if (!newToken) {
          throw new Error("Token not found in API response");
        }
        localStorage.setItem('_token', newToken);
    }catch(error){
        console.error('Error in refreshing token', [error]);
        localStorage.removeItem("_token");
    }
}

export const getUser = async() => {
  try{
    const token = localStorage.getItem("_token");
    if (token) {
        const user = jwtDecode(token);
        if (!user || !user.id) throw new Error("Invalid token payload");
        return user
    }else{
      return null;
    }
  }catch(error){
    console.error("Error in fetching user details", error)
    return null;
  }
}